export const CropwiseAiHistoryMenuKey = {
  DELETE_CHAT: 'deleteChat',
};
